interface Comment {
  name: string;
  avatar: string;
  date: string;
  content: string;
  comic: string;
  rating: number;
}

const comments: Comment[] = [
  {
    name: '漫画迷小樱',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20female%20avatar%20portrait%2C%20soft%20pink%20hair%2C%20warm%20smile%2C%20simple%20light%20background%2C%20clean%20illustration%20style%2C%20minimalist%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '3天前',
    content: '贝勒漫画真的是我用过最好用的漫画阅读平台！加载速度快，画质清晰，而且更新很及时。霸道总裁的契约新娘每周都准时追，根本停不下来！',
    comic: '《霸道总裁的契约新娘》',
    rating: 5,
  },
  {
    name: '剑道修行者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20male%20avatar%20portrait%2C%20short%20dark%20hair%2C%20determined%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20minimalist%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '5天前',
    content: '《剑道至尊》画风太赞了！每一话都像壁纸级别的质量，剧情也是一环扣一环。国漫能有这样的水准真的让人惊喜，强烈推荐！',
    comic: '《剑道至尊》',
    rating: 5,
  },
  {
    name: '深夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20sleepy%20anime%20style%20female%20avatar%20portrait%2C%20messy%20brown%20hair%2C%20wearing%20glasses%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20minimalist%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '1周前',
    content: '夜间模式真的太好用了，深夜看漫画眼睛不会酸。离线下载功能也很实用，地铁上没信号也能继续追更。贝勒漫画APP体验满分！',
    comic: '贝勒漫画APP',
    rating: 5,
  },
  {
    name: '日漫老司机',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20male%20avatar%20portrait%2C%20spiky%20blonde%20hair%2C%20confident%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20minimalist%20design&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '2周前',
    content: '日漫资源很全，连比较冷门的作品都能找到。翻译质量也很高，读起来完全没有违和感。希望以后能引进更多日本原版漫画！',
    comic: '《咒术战线》',
    rating: 4,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">读者心声</h2>
          <p className="text-sm text-foreground-500">来自贝勒漫画读者的真实评价</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-100 rounded-xl p-5 border border-background-200/60"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-foreground-900">{comment.name}</span>
                    <span className="text-xs text-foreground-400">{comment.date}</span>
                  </div>
                  <div className="text-xs text-primary-500 mt-0.5">{comment.comic}</div>
                </div>
                <div className="flex items-center gap-0.5 flex-shrink-0">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                  ))}
                </div>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}